module.exports = __webpack_public_path__ + "static/media/login-screen.097b3465.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login-screen.png
// module id = 138
// module chunks = 0